/**
 * AppHeader — Unified top bar for v2.
 * Zone4 logo + title on left, single ⋯ menu on right.
 */
import React, { useState, useRef, useEffect } from 'react';
import logo from '../../logos/zone4.png';
import './AppHeader.css';

function AppHeader({ version, onClearAll, onOpenFisPoints, onOpenUssaPoints }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="app-header" ref={headerRef}>
      <div className="app-header-left">
        <img src={logo} alt="Zone 4" className="app-header-logo" />
        <h1 className="app-header-title">FIS / USSA Results Processor</h1>
      </div>

      <div className="app-header-right">
        <button
          className="header-menu-btn"
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Menu"
        >⋯</button>
        {menuOpen && (
          <div className="header-dropdown">
            <a href="/documentation" className="dropdown-item" onClick={() => setMenuOpen(false)}>
              Documentation
            </a>
            <div className="dropdown-divider" />
            <button className="dropdown-item" onClick={() => { onClearAll(); setMenuOpen(false); }}>
              Clear All Data
            </button>
            <div className="dropdown-divider" />
            <button className="dropdown-item" onClick={() => { onOpenFisPoints(); setMenuOpen(false); }}>
              Download FIS Points
            </button>
            <button className="dropdown-item" onClick={() => { onOpenUssaPoints(); setMenuOpen(false); }}>
              Download USSA Points
            </button>
            <div className="dropdown-divider" />
            <a href="/fis" className="dropdown-item legacy-item">Legacy FIS Process</a>
            <a href="/ussa" className="dropdown-item legacy-item">Legacy USSA Process</a>
            <div className="dropdown-divider" />
            <div className="dropdown-item dropdown-version">v{version}</div>
          </div>
        )}
      </div>
    </header>
  );
}

export default AppHeader;
